const USER_PROFILE = "USER_PROFILE";
const names = {
  USER_PROFILE
};
export { names as default, USER_PROFILE };
